$(document).ready(function() {
  // Grab the feed
  $.ajax({
    type: "GET",
    url: "/news/rss/rss.xml",
    dataType: "xml",
    success: parseXml
  });
  
  function parseXml(xml)
  {
    var limit = 5; // Set item limit 
    
    $(xml).find("item").each(function(i, val)
    {
      // Item Limiter
      if(i > limit-1) return false;
      // Each element from xml
      var title = $(this).find("title").text(),
      grabDesc = $(this).find("description").text(),
      // Truncates the description line - current 65 characters
      description = jQuery.trim(grabDesc).substring(0, 65).split(" ").slice(0, -1).join(" ") + "...",
      link = $(this).find("link").text();
      
      // Render the feed items
      var feedTemplate = '<p class="newsItem"><a href="'+ link +'">' + title + '</a><br />' + description + '</p>';
      // Output Feed Items
      $('#rssFeedOutput').append(feedTemplate);
    });
  }
});